import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import AlertDialog from "components/Dialog";
import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";

const LeftMenu = ({
  types,
  btnText,
  getTypeId,
  disableAddNew,
  setAddNew,
  setDisable,
  setDaisableAddNew,
  addPath,
  accounts,
  forceSelectedId,
}) => {
  const { push } = useHistory();
  const location = useLocation();

  const [selected, setSelected] = useState("");
  const [Id, setId] = useState();

  useEffect(() => {
    if (!forceSelectedId) return;
    const match = (types || accounts || []).find(
      (item) => (item?._id || item?.id) === forceSelectedId
    );
    if (match) {
      setSelected(match?.title ?? match?.type ?? match?.ar_name ?? "");
      setId(forceSelectedId);
    }
  }, [forceSelectedId, types, accounts]);
  const [openDisableAlert, setOpenDisableAlert] = useState(false);
  const handleCloseDialog = () => {
    setOpenDisableAlert(false);
  };
  const handleCancel = (e) => {
    setOpenDisableAlert(false);
    e.preventDefault();
    push({
      pathname: location.pathname.replace("edit", "view"),
    });
  };
  const addNew = (e) => {
    e.preventDefault();
    setAddNew(true);
    setDisable(true);
    setDaisableAddNew(true);
    push({
      pathname: addPath,
    });
  };
  const onTypeClick = (type, id) => {
    if (location.pathname.includes("edit")) {
      setOpenDisableAlert(true);
    } else {
      getTypeId(type, id);
      setSelected(type);
      setId(id);
    }
    if(window.scrollY > 280) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };


  // useEffect(() => {
  //   setSelected("");
  //   setId("");
  // }, [accounts]);

  return (
    <div className="w-100">
      <AlertDialog
        open={openDisableAlert}
        handleClose={handleCloseDialog}
        onDecline={() => {
          setOpenDisableAlert(false);
        }}
        onAccept={handleCancel}
        title={" Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
      {disableAddNew === true ? (
        <Link
          type="button"
          class="btn btn-primary leftmenu-btn mb-3  mt-5"
          onClick={addNew}
          disabled
        >
          <PlusIcon /> {btnText}
        </Link>
      ) : (
        <Link
          type="button"
          class="btn btn-primary mb-3 leftmenu-btn mt-5"
          onClick={addNew}
        >
          <PlusIcon /> {btnText}
        </Link>
      )}
      {accounts ? (
        <div className="mt-5 ">
          {accounts?.map((item, index) => (
            <div
              className={
                (selected === item.ar_name || selected === item.ar_name) &&
                (Id === item?.ar_id || Id === item?._id)
                  ? "type-select p-5 bg-white text-dark left-menu-items"
                  : !selected && index === 0
                  ? "type-select p-5 bg-white text-dark left-menu-items"
                  : "p-5 bg-white text-dark left-menu-items"
              }
              onClick={() =>
                onTypeClick(
                  item?.ar_name ?? item?.ar_name,
                  item?._id ?? item?._id
                )
              }
            >
              {item?.ar_name ?? item?.ar_name}
              <span style={{ color: "grey", marginLeft: "50px" }}>
                {item?.ar_id}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <div className="mt-5 ">
          {types?.map((item, index) => (
            <div
              className={
                (selected === item.type || selected === item.title) &&
                (Id === item?.id || Id === item?._id)
                  ? "type-select p-5 bg-white text-dark left-menu-items"
                  : !selected && index === 0
                  ? "type-select p-5 bg-white text-dark left-menu-items"
                  : "p-5 bg-white text-dark left-menu-items"
              }
              onClick={() =>
                onTypeClick(item?.title ?? item?.type, item?.id ?? item?._id)
              }
              title={item?.title ?? item?.type}
            >
              {item?.title && item.title !== undefined && item.title.length > 20
                ? item?.title.substring(0, 20)
                : item?.title}
              {item?.type && item.type !== undefined && item.type.length > 20
                ? item?.type.substring(0, 20)
                : item?.type}
              <span style={{ color: "grey", marginLeft: "50px" }}>
                {item?.is_default === true ? "Default" : ""}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LeftMenu;
